import React, { useState, useRef, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

const Dropdown = ({ 
  trigger, 
  children, 
  className,
  align = "right",
  ...props 
}) => {
  const { theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const alignmentClasses = {
    left: "left-0",
    right: "right-0",
    center: "left-1/2 transform -translate-x-1/2"
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef} {...props}>
      {/* Trigger */}
      <div onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className={cn(
          `absolute z-50 mt-2 w-48 ${alignmentClasses[align]} ${theme.colors.surface} ${theme.border.light} border rounded-lg ${theme.shadow.lg}`,
          className
        )}>
          <div className="py-1">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

const DropdownItem = ({ 
  onClick, 
  children, 
  className,
  disabled = false,
  ...props 
}) => {
  const { theme } = useTheme();

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={cn(
        `w-full text-left px-4 py-2 text-sm ${theme.text.primary} hover:${theme.colors.background} transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed`,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

const DropdownSeparator = ({ className }) => {
  const { theme } = useTheme();
  
  return (
    <div className={cn(`my-1 h-px ${theme.border.light} border-t`, className)} />
  );
};

export { Dropdown, DropdownItem, DropdownSeparator };
